import { ArrowForward, Assignment, AssignmentTurnedIn } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Card, CardContent, CardHeader, Chip, Container, CssBaseline, Grid, IconButton, Stack, Tab, Tooltip } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useOutletContext } from 'react-router-dom'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import MyTable from '../../../../components/MyTable';
import { AuthStore, NotifStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import { DataAcc } from '../Acc/Index';

const Spm = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Verifikasi Dokumen" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [value, setValue] = useState('1');

    useEffect(() => {
        setBreadcrumbItem({ '/verif': 'Home', '/verif/spm': 'Verifikasi Dokumen' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Periksa">
                            <IconButton aria-label="edit" color="info" component={Link} to="periksa" state={params.row}>
                                <ArrowForward />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            }
        },
        {
            field: 'progres',
            headerName: 'Status',
            sortable: false,
            filterable: false,
            hideable: false,
            width: 120,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                let label = "";
                let color = "";

                switch (params.row.progres) {
                    case "0":
                        label = "Baru";
                        color = "primary";
                        break;
                    case "1":
                        label = "Diperbaiki"
                        color = "info";
                        break;
                    case "2":
                        label = "Ditolak";
                        color = "error"
                        break;
                    case "3":
                        label = "Acc";
                        color = "success";
                        break;

                    default:
                        break;
                }

                return (
                    <Chip
                        label={label}
                        color={color}
                        variant="outlined"
                    />
                )
            },
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = () => {
        setTableLoading(true)
        axios.get(
            base_url + '/verif/pencairan/no_acc',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    const pemberitahuans = NotifStore((state) => state.pemberitahuans);
    const [reqData, setReqData] = useState(true);

    useEffect(() => {
        console.log(pemberitahuans);
        pemberitahuans.length > 0 && setReqData(!reqData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pemberitahuans]);

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reqData]);

    return (
        <Card>
            <CardHeader
                title="DATA SPM"
            />
            <CardContent>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab icon={<Assignment />} label="SPM Diajukan" value="1" />
                                <Tab icon={<AssignmentTurnedIn />} label="SPM Disetujui" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <MyTable
                                rows={tableData}
                                columns={columns}
                                row_id={(row) => row.no_spm}
                                isLoading={tableLoading}
                            />
                        </TabPanel>
                        <TabPanel value="2">
                            <DataAcc />
                        </TabPanel>
                    </TabContext>
                </Box>
            </CardContent>
        </Card>
    )
}

export default Spm
export { Data as DataSpm }